import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { PROFILE_PROXY_ACTION_HAVE_CREDIT, PROFILE_PROXY_ACTION_LABELS, ProfileProxySide } from "@/entities/IProxy";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import type { ApiProfileProxyAction } from "@/generated/models/ApiProfileProxyAction";
import { getTimeAgo } from "@/helpers/Helpers";
import { getProfileProxyActionStatus } from "@/helpers/profile-proxy.helpers";
import ProxyActionAcceptanceButton from "../action/ProxyActionAcceptanceButton";
import ProfileProxyCredit from "../action/utils/credit/ProfileProxyCredit";
import ProfileProxyCreditSpent from "../action/utils/credit/ProfileProxyCreditSpent";
import ProfileProxyEndTime from "../action/utils/time/ProfileProxyEndTime";
import { PROXY_ACTION_ROW_VIEW_MODE } from "./ProxyActionRow";
import ProxyActionRowStatus from "./ProxyActionRowStatus";
export default function ProxyActionRowDataMode(t0) {
  const $ = _c(54);
  const {
    action,
    profileProxy,
    profile,
    isSelf,
    setViewMode
  } = t0;
  let t1;
  if ($[0] !== action) {
    t1 = getProfileProxyActionStatus({
      action,
      side: ProfileProxySide.GRANTED
    });
    $[0] = action;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const grantorStatus = t1;
  let t2;
  if ($[2] !== action) {
    t2 = getProfileProxyActionStatus({
      action,
      side: ProfileProxySide.RECEIVED
    });
    $[2] = action;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const receiverStatus = t2;
  const t3 = PROFILE_PROXY_ACTION_LABELS[action.action_type];
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="tw-col-span-full md:tw-col-span-2"><div className="tw-flex tw-items-center tw-gap-x-3"><p className="tw-mb-0 tw-text-md tw-font-medium tw-text-iron-50">{t3}</p></div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== grantorStatus || $[7] !== profileProxy.created_by) {
    t5 = <ProxyActionRowStatus status={grantorStatus} statusOwnerProfile={profileProxy.created_by} side={ProfileProxySide.GRANTED} />;
    $[6] = grantorStatus;
    $[7] = profileProxy.created_by;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== profileProxy.granted_to || $[10] !== receiverStatus) {
    t6 = <ProxyActionRowStatus status={receiverStatus} statusOwnerProfile={profileProxy.granted_to} side={ProfileProxySide.RECEIVED} />;
    $[9] = profileProxy.granted_to;
    $[10] = receiverStatus;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="tw-col-span-full md:tw-col-span-3"><div className="tw-flex tw-gap-3 md:tw-flex-col lg:tw-flex-row">{t5}{t6}</div></div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== action || $[16] !== profileProxy || $[17] !== setViewMode) {
    t8 = PROFILE_PROXY_ACTION_HAVE_CREDIT[action.action_type] && <ProfileProxyCredit profileProxy={profileProxy} profileProxyAction={action} onCreditEdit={() => setViewMode(PROXY_ACTION_ROW_VIEW_MODE.CREDIT_EDIT)} />;
    $[15] = action;
    $[16] = profileProxy;
    $[17] = setViewMode;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <div className="tw-col-span-full md:tw-col-span-2">{t8}</div>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== action) {
    t10 = PROFILE_PROXY_ACTION_HAVE_CREDIT[action.action_type] && <ProfileProxyCreditSpent profileProxyAction={action} />;
    $[21] = action;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10) {
    t11 = <div className="tw-col-span-full md:tw-col-span-2">{t10}</div>;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span>Start:</span>;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== action.start_time) {
    t13 = getTimeAgo(action.start_time);
    $[26] = action.start_time;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = <p className="tw-mb-0 tw-flex tw-items-center tw-space-x-1 tw-whitespace-nowrap tw-text-md tw-font-normal tw-leading-6 tw-text-iron-500">{t12}<span className="tw-font-normal tw-text-iron-300">{t13}</span></p>;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="tw-text-md tw-font-normal tw-text-iron-500">End:</span>;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== setViewMode) {
    t16 = () => setViewMode(PROXY_ACTION_ROW_VIEW_MODE.END_TIME_EDIT);
    $[31] = setViewMode;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== action || $[34] !== profileProxy || $[35] !== t16) {
    t17 = <div className="tw-flex tw-items-center tw-space-x-1">{t15}<ProfileProxyEndTime profileProxy={profileProxy} profileProxyAction={action} onEndTimeEdit={t16} /></div>;
    $[33] = action;
    $[34] = profileProxy;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t14 || $[38] !== t17) {
    t18 = <div className="tw-col-span-full md:tw-col-span-4"><div className="tw-flex tw-gap-x-6 tw-gap-y-3 md:tw-flex-col lg:tw-flex-row">{t14}{t17}</div></div>;
    $[37] = t14;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== action || $[41] !== isSelf || $[42] !== profile || $[43] !== profileProxy) {
    t19 = isSelf && <ProxyActionAcceptanceButton action={action} profile={profile} profileProxy={profileProxy} />;
    $[40] = action;
    $[41] = isSelf;
    $[42] = profile;
    $[43] = profileProxy;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t19) {
    t20 = <div className="tw-col-span-full md:tw-col-span-2">{t19}</div>;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t11 || $[48] !== t18 || $[49] !== t20 || $[50] !== t4 || $[51] !== t7 || $[52] !== t9) {
    t21 = <div className="tw-relative tw-grid tw-w-full tw-grid-cols-[repeat(15,minmax(0,1fr))] tw-justify-between tw-gap-x-4 tw-gap-y-3 tw-px-4 tw-py-4 lg:tw-items-center xl:tw-h-14 xl:tw-py-0">{t4}{t7}{t9}{t11}{t18}{t20}</div>;
    $[47] = t11;
    $[48] = t18;
    $[49] = t20;
    $[50] = t4;
    $[51] = t7;
    $[52] = t9;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  return t21;
}